const SIZES = {
  DATE: 25,
  CONTENT: 60,
  AUTHOR: 15,
};

export default SIZES;
